import userModule from "@lab/store/user.module";
import router from "@/router";

const state = {
	...userModule.state
};
const getters = {
	...userModule.getters
};
const actions = {
	...userModule.actions,
	logout({ dispatch }) {
		router.push({ name: "Login" });
		dispatch("clear");
	}
};

const mutations = {
	...userModule.mutations
};

export default { namespaced: true, state, getters, actions, mutations };
